import { Pipe, PipeTransform } from "@angular/core";
import { Constant } from "../../pages/general/blog/constant";

@Pipe({
  name: "image",
  standalone: true,
})
export class PortalImagePipe implements PipeTransform {
  cacheImage!: string;
  constructor(
  ) {}
  transform(url: string): string {
    return Constant.url_portal_images + url;
  }

  
}
